import { CompanyStructureProfitCenter, CompanyStructureForPlanningResponse } from '@/types/service-response'

export class ProfitCenter {
  private constructor (
    readonly id: number, // ProfitCenterID
    readonly code: string, // Code
    readonly reserveCurrency: number, // LeitWaehrung
    readonly MWStNr: string, // MWStNr
    readonly referenceNumberConstruction: string, // ReferenzNummerAufbau
    readonly subscriberNumber: string, // TeilnehmerNummer
    readonly targetAccountNumber: string, // ZielkontoNummer
    readonly language: number | null, // Sprache
    readonly PBID: number, // PBID
    readonly label: string, // Bezeichnung
    readonly addressId: number,
    readonly addressName: string,
    readonly addressNumber: number
  ) {
  }

  static createFromResponse (responseData: CompanyStructureForPlanningResponse): Array<ProfitCenter> {
    let result: Array<ProfitCenter> = []
    if (responseData.profitCenters) {
      result = responseData.profitCenters.map((profitCenter: CompanyStructureProfitCenter) => {
        return new ProfitCenter(
          profitCenter.ProfitCenterID,
          profitCenter.Code,
          profitCenter.LeitWaehrung,
          profitCenter.MWStNr,
          profitCenter.ReferenzNummerAufbau,
          profitCenter.TeilnehmerNummer,
          profitCenter.ZielkontoNummer,
          profitCenter.Sprache,
          profitCenter.PBID,
          profitCenter.Bezeichnung,
          parseInt(profitCenter.AdressID),
          profitCenter.AdressName,
          profitCenter.AdressNummer
        )
      })
    }
    return result
  }
}